import { defineComponent as _defineComponent } from 'vue'
import SFButton from '@/components/ui/button/Button.vue'
import Checkbox from '@/components/ui/checkbox/Checkbox.vue'
import { inject, ref } from 'vue'
import { onClickOutside } from '@vueuse/core'
import { FireRiskDashboardViewModel } from '../viewmodels/FireRiskDashboard.viewmodel'
import { FireAlertsTableHeadersFactory } from '../factories/FireAlertsTableHeaders.factory'


export default /*#__PURE__*/_defineComponent({
  __name: 'FireAlertsColumnsSelector',
  setup(__props) {

const vm = inject<FireRiskDashboardViewModel>('fire-risk-dashboard-viewmodel')!

const selector = ref()

const isOpen = ref(false)

onClickOutside(selector, () => (isOpen.value = false))

return { __sfc: true,vm, selector, isOpen, SFButton, Checkbox, FireAlertsTableHeadersFactory }
}

})